import { useEffect, useState } from 'react';
import { useRhinoContext } from '@rhino-project/core';
import { useBaseOwnerId } from '@rhino-project/core/hooks';

export const AppOwnerProvider = ({ children }) => {
  const rhino = useRhinoContext();
  const baseOwnerId = useBaseOwnerId();

  const user = rhino.user;
  const [resolving, setResolving] = useState(true);

  useEffect(() => {
    if (!user) {
      rhino.setBaseOwner?.(null);
      setResolving(false);
      return;
    }

    const roles = user.users_roles ?? rhino.usersRoles ?? [];
    if (!rhino.baseOwner && !baseOwnerId && roles.length > 0) {
      rhino.setBaseOwner?.(roles[0].organization);
    }
    setResolving(false);
  }, [user, rhino, baseOwnerId]);

  if (user && resolving) return null;
  return children;
};
